import { maxFileSize } from '../../../constants/maxFileSize';
import { mbToBytes } from '../../../helpers/attachments/mbToBytes';

export const fileSizeValidator = (_rule, value, callback) => {
  if (value?.length) {
    const bigFiles = value.filter((file) => file.size > maxFileSize);

    if (bigFiles.length) {
      callback(`Размер выделенных файлов превышает 15 Мб`);
    } else {
      callback();
    }
  } else {
    callback();
  }
};

export const createFileSizeValidator =
  (maxSizeMb, errorMsg) => (_rule, value, callback) => {
    if (value?.length) {
      const maxSize = mbToBytes(maxSizeMb);
      const bigFiles = value.filter((file) => file.size > maxSize);

      if (bigFiles.length) {
        callback(
          errorMsg || `Размер выделенных файлов превышает ${maxSizeMb} Мб`
        );
      } else {
        callback();
      }
    } else {
      callback();
    }
  };
